import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import { toCSSColor } from '@printu/geom';
const Consts = {
    swatchWidthRange: {
        min: 20,
        max: 70,
    },
};
export const getMarkerSizeRange = (sizes) => sizes.reduce((accum, value) => {
    accum.min = Math.min(accum.min, value);
    accum.max = Math.max(accum.max, value);
    return accum;
}, { min: sizes[0], max: sizes[0] });
export const markerSizeLerp = (value, sizeRange) => Math.max(Consts.swatchWidthRange.min, Math.min(Consts.swatchWidthRange.max, Consts.swatchWidthRange.min +
    ((value - sizeRange.min) / (sizeRange.max - sizeRange.min)) *
        (Consts.swatchWidthRange.max - Consts.swatchWidthRange.min)));
export const SizeIcon = (props) => {
    const { color, size, sizeRange, drawBackground = true } = props;
    const commonStyle = {
        borderRadius: '10%',
        backgroundColor: toCSSColor(color),
        width: '100%',
    };
    return (React.createElement(Flex, { width: "100%", height: "100%", position: "relative", alignItems: "center", justifyContent: "center" },
        React.createElement("span", { style: Object.assign(Object.assign(Object.assign({}, commonStyle), { position: 'absolute', height: `${Consts.swatchWidthRange.max + 20}%`, backgroundColor: 'transparent' }), (drawBackground && {
                backgroundColor: 'var(--spectrum-alias-background-color-gray-200, var(--spectrum-global-color-gray-200, var(--spectrum-semantic-gray-200-color-background)))',
                border: '1px solid #cdcdcd',
            })) }, "\u00A0"),
        React.createElement("span", { style: Object.assign(Object.assign({}, commonStyle), { position: 'absolute', width: '80%', height: `${markerSizeLerp(size, sizeRange).toFixed(2)}%` }) }, "\u00A0")));
};
